import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class VaultCards extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "VaultCards";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      request_id: null,
      type: null,
      brand: null,
      nickname: null,
      number: null,
      month: null,
      year: null,
      cardholder: null,
      bin: null,
      category: null,
      issuer: null,
      first_6: null,
      last_4: null,
      cvv: null,
      save_token: false,
      send_receipt: true,
      payment_type: 'CREDIT_CARD',
      billing_address: {
        street_1: null,
        street_2: null,
        city: null,
        state_code: null,
        postal_code: null,
        country_code: null,
        latitude: null,
        longitude: null,
        use_shipping: false
      },
      is_test: false,
      valid_card: false,
      notes: [],
      tags: [],
      customer_id: null,
      company_id: null,
      contact_id: null,
      profile_id: null,
      customer: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    return data;
  }
}
